// removed by extract-text-webpack-plugin
module.exports = {"block":"_3rv2NC-2czlTSB-0-z4uxE","block-content":"_1yLY0I-1yJcYW67UszaP44","list-content":"_2O1jX1il5p1vN-TmP41q88","heading":"YEMQRlU9a-OhS3tSTRdQW","text":"_3Fg3Re_MYSRfvKiFYGbwqJ","zebra":"_1PoWPSQr3emxDz6yvGL_jO","yellow":"_2rM1cSVw2V4iMR7-GnxYfA","darkgray":"V-WsIIoQVFptr39AVHp7k","list":"_3zXfJNv9whuatUSOs2yHH8","listItem":"_1NjsPjtovJUK5_p6LirI-5","icon":"_2vItupI323Voj3S0tpmHU3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupedLinksBlock/GroupedLinksBlock.module.scss
// module id = 772
// module chunks = 0